import { useMediaQuery } from "@mui/system";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import permissions from "app/permissions";
import { MobileListRow } from "features/MobileListRow";
import { Datagrid, EditButton, List, ReferenceField, ShowButton, SimpleList, TextField } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListUniversities = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Списък университети"
      sx={settings.style.blockStyle}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record?.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Държава",
                    value: (
                      <ReferenceField
                        label="Държава"
                        source="countryId"
                        reference={administrationRequests.getCountriesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Град", value: record?.city }]} />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageExternalUniversities}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewExternalUniversities}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            label="Име"
            source="name"
            sortable={false}
          />

          <ReferenceField
            label="Държава"
            source="countryId"
            reference={administrationRequests.getCountriesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <TextField
            label="Град"
            source="city"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canManageExternalUniversities}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewExternalUniversities}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListUniversities;
